import { Navigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../context/authcontext";
import Unauthorized from "../Unauthorized/Unauthorized";
import { useIsVoormanOnAnyProject } from "../../hooks/useIsVoormanOnAnyProject";
import PropTypes from "prop-types";
import Loader from "../Loader/Loader";

function RequireAuth({ children, allowedRoles, allowVoorman = false, fallback = null }) {
    const { t } = useTranslation();
    const { auth, loading } = useAuth();
    const { isVoorman, loading: voormanLoading } = useIsVoormanOnAnyProject();
    const location = useLocation();

    if (loading || (allowVoorman && voormanLoading)) {
        return <Loader message={t('common.loading')} />;
    }

    if (!auth.isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    const allowed = allowedRoles && allowedRoles.includes(auth.role);

    if (!allowed && !(allowVoorman && isVoorman)) {
        return fallback || <Unauthorized />;
    }

    return children;
}

RequireAuth.propTypes = {
    children: PropTypes.node.isRequired,
    allowedRoles: PropTypes.arrayOf(PropTypes.string),
    allowVoorman: PropTypes.bool,
    fallback: PropTypes.node
};

RequireAuth.defaultProps = {
    allowedRoles: [],
    allowVoorman: false,
    fallback: null
};

export default RequireAuth;
